export default class MerfotoCardSubHeader extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
  }

  render() {
    const {children, className, ...restProps} = this.props

    return (
      <div className={classNames("merfoto-components-card-sub-header", "p-2", className)} {...restProps}>
        {children}
      </div>
    )
  }
}
